import { createContext } from "react";

const SystemContext = createContext({});

export const ERPContext = createContext({});

export default SystemContext;
